// @ts-nocheck
import * as React from "react";
import { Ic } from "../screens/common";
import { useEscapeKey } from "./useEscapeKey";

// 테이블 행의 보조·위험 액션을 ⋯ 버튼 뒤로 접는 오버플로 메뉴.
//
// 한 행에 액션 버튼이 4~5개씩 인라인으로 깔리면 작업 컬럼 폭이 들쭉날쭉해지고
// 시선이 분산된다. 자주 쓰는 1차 액션만 행에 두고(예: 편집), 나머지는 이 메뉴로
// 접어 작업 컬럼을 항상 일정 폭으로 고정한다.
//
// items: { label, onClick, danger?, color?, disabled?, title?, dividerBefore? }[]
//  - null/false/undefined 항목은 걸러져서, 조건부 액션을 `cond && {...}` 형태로
//    그냥 배열에 넣어도 된다.
//  - danger=true → rose 색 + 굵게(탈퇴 등 파괴적 액션 시각 구분).
//  - dividerBefore=true → 항목 위에 구분선(위험 액션을 한 칸 떨어뜨릴 때).
//  - 보이는 항목이 0개면 아무것도 렌더하지 않는다(권한 없는 행의 빈 버튼 방지).
//
// placement: "down"(기본, 트리거 아래) | "up"(트리거 위). overflow:hidden 카드
// 푸터처럼 아래 공간이 잘리는 곳에선 "up"으로 카드 안쪽으로 펼친다.
export function RowMenu({ items, label = "추가 작업", placement = "down" }) {
  const [open, setOpen] = React.useState(false);
  const visible = (items || []).filter(Boolean);
  useEscapeKey(() => setOpen(false), open);
  if (visible.length === 0) return null;

  const itemStyle = (it) => ({
    display: "block", width: "100%", textAlign: "left",
    border: "none", borderRadius: 6, padding: "7px 10px",
    color: it.danger ? "var(--rose-500)" : (it.color || "var(--ink-1)"),
    fontWeight: it.danger ? 700 : 600,
    opacity: it.disabled ? 0.45 : 1,
    cursor: it.disabled ? "not-allowed" : "pointer",
  });

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button className="btn btn-ghost btn-sm" aria-label={label} title={label}
        aria-haspopup="menu" aria-expanded={open}
        onClick={() => setOpen(v => !v)}
        style={{ padding: "6px 8px", ...(open ? { background: "var(--surface-2)" } : null) }}>
        {Ic.more}
      </button>
      {open && (
        <>
          {/* 바깥 클릭 시 닫기용 투명 백드롭 */}
          <div onClick={() => setOpen(false)}
            style={{ position: "fixed", inset: 0, zIndex: 40 }} />
          <div className="card" role="menu"
            style={{
              position: "absolute", right: 0,
              ...(placement === "up"
                ? { bottom: "calc(100% + 4px)" }
                : { top: "calc(100% + 4px)" }),
              minWidth: 172, padding: 4, zIndex: 41,
              boxShadow: "var(--shadow-lg)", textAlign: "left",
            }}>
            {visible.map((it, i) => (
              <React.Fragment key={i}>
                {it.dividerBefore && i > 0 && (
                  <div style={{ height: 1, background: "var(--border-soft)", margin: "4px 2px" }} />
                )}
                <button role="menuitem" className="btn btn-ghost" disabled={it.disabled}
                  title={it.title}
                  onClick={() => { setOpen(false); it.onClick?.(); }}
                  style={itemStyle(it)}>
                  {it.label}
                </button>
              </React.Fragment>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
